import { SiderMenu } from 'bricks-ui/packages/bricks-ui';

export default SiderMenu;
